
<template lang="html">
<div>
    <v-header backTo="Login profissional">
        <router-link :to="{name: 'vibbrant-login'}" class="linkLogin">
          Sou profissional
        </router-link>
    </v-header>
  <v-page class="recover-pass" :profile="profile" :style="{ backgroundImage: `url(${img_background_url})` }">
    <div class="autoLogin">
      <v-login class="card-login">
        <div class="center">
          <div class="loginLeft">
            <div class="company">
              <p>E</p>
              <p>M</p>
              <p>P</p>
              <p>R</p>
              <p>E</p>
              <p>S</p>
              <p>A</p>
            </div>

            <div>
              <img class="photo" :src="img_url">
            </div>
          </div>
          <div class="loginRight">
             <div class="card-login">

          <div v-if="sent">

              <v-logo class="mb-4" />
              <v-text
                >Link para recuperação de senha enviado para <b>{{ email }}</b>
              </v-text>


            <v-button
              class="block primary mt-2"
              :to="{ name: 'vibbrant-login' }"
              >Ir para o login</v-button
            >
          </div>
          <form v-else @submit.prevent="send()">
            <div class="aling">
              <img  src="static/logo.svg?v=1" class="imgLogo" alt="" />
            <div  class="titleCenter"
              >Recuperar senha</div>
            </div>
            <v-input type="email" id="signin-email" v-model="email"
              >E-mail da conta</v-input
            >
            <v-button type="submit" class="block primary mt-2">Enviar</v-button>
          </form>

      </div>
          </div>
        </div>
      </v-login>
    </div>
  </v-page>
</div>
</template>

<script>
import apiClient from '@/api/client';
import apiVibbrante from '@/api/vibbrante';

export default {
  props: {
    profile: String,
  },
  data() {
    return {
      sent: false,
      email: '',
   img_url: require('../../assets/photoPeople/Planos-Enterprise.png'),
      img_background_url: require('../../assets/background/fundoAzul.svg'),

    };
  },
  methods: {
    send() {
      if (this.profile === 'vibbrant') {
        apiVibbrante.revoveryPass(this.email).then(response => {
          if (response.status === 200) {
            this.sent = true;
          }
        });
      } else {
        apiClient.revoveryPass(this.email).then(response => {
          if (response.status === 200) {
            this.sent = true;
          }
        });
      }
    },
  },
};
</script>

<style lang="scss">
.linkLogin{
     color: white !important;

  &:hover{
    color: #0377AA !important;
      text-decoration: none;
  }


    }
.registeHere{
  color: #0377AA !important;

  &:hover{
    color: #0377AA !important;
    text-decoration: none;
  }
}
.page {
    min-height: calc(100vh - 60px);
}
.recover-pass{
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  background-size: cover;
  background-repeat: no-repeat;

  .autoLogin {
    width: 75%;
    flex: 1;
    justify-content: center;
    align-items: center;
    display: flex;
  }

  .card-login {
    max-width: 100%;
    flex-basis: auto;
    flex-grow: 1;
    border-radius: 22px;
    justify-content: center;
    @include media-breakpoint-up(md) {
      width: 100%;
    }
    .center {
      display: flex;
      align-items: center;
      padding: 2rem 2rem 0 0;

      @include media-breakpoint-down(md) {
        padding: 2rem;
      }
    }
    .loginLeft {
      display: flex;
      align-items: flex-end;

      height: 100%;
      width: 60%;
      @include media-breakpoint-down(md) {
        display: none;
      }
    }

    .company {
      background-color: #0377aa;
      color: white;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 10px 25px;
      height: calc(100vh - 450px);
      align-items: center;
      font-weight: 700px;
      font-weight: 700;
      font-size: 20px;
      border-radius: 0 10px 0 20px;

      p {
        margin: 0;
      }
    }
    .loginRight {
      width: 40%;
      @include media-breakpoint-down(md) {
        width: 100%;
      }
    }

    .logo {
      height: 60px;
      text-align: center;
      margin: 0 0 30px 0;
    }


    .photo {
      height: 500px;
    }

    .titleLoginEmpresa{
      font-size: 45px;
      font-weight: bold;
      margin-bottom: 40px;
      text-align: center;

      @include media-breakpoint-down(md) {
        font-size: 35px;
      }
    }
    .dataRadio {
      display: flex;
      align-items: center;
    }
    .inputRadio {
      margin: 0 !important;
    }
    .aling {
      display: flex;
      align-items: center;
      text-align: center;
      justify-content: center;
      flex-direction: column;
    }
    .titleCenter{
      font-size: 25px;
      font-weight: 600;
      margin-bottom:60px ;
    }

    .imgLogo{
      width: 200px;
      margin-bottom: 20px;
    }
    .helpers {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
      }
    }
    .register {
      display: flex;
      justify-content: center;
      gap: 1rem;
      margin-top: 20px;
      @include media-breakpoint-down(md) {
        flex-direction: column;
        text-align: center;
        gap: 0;
        p {
          margin: 0;
        }
      }
    }
  }
  footer.page-footer {
    color: white;
    margin-top: auto;
  }
}
</style>


  footer.page-footer {
    margin-top: auto;
  }

</style>



// WEBPACK FOOTER //
// src/parts/pages/recover-pass.vue